/* PAC */
export interface PACDTO {
    id?: string
    year?: string
    norm?: string
    note?: string
    startingDate?: Date
    endingDate?: Date
    userId?: string
}

export interface PACErrorsDTO {
    year: boolean
    norm: boolean
    startingDate: boolean
    endingDate: boolean
}

export interface GetAllPACsDTO {
    total: number,
    page: number,
    perPage: number | null,
    prev: string | null,
    next: string | null,
    totalPage: number | null,
    data: PACDTO[]
}

export interface GetAllPACsFiltersDTO {
    page: number
    itemsPerPage: number
    order?: boolean
    sort?: string
}

/* PAC DETAILS */

export interface PACDetailCreationDTO {
    periodicity: number[]
    mode?: PACVisitingModeEnum
    visitType?: PACVisitingTypeEnum
    sampling?: boolean
    specifications: string
    note?: string
    customerId: string
    annualControlPlaneId: string
}

export interface PACDetailUpdateDTO {
    periodicity?: number[]
    mode?: PACVisitingModeEnum
    visitType?: PACVisitingTypeEnum
    sampling?: boolean
    specifications?: string
    annualControlPlaneId?: string
    note?: string
}

export interface PACDetailErrors {
    periodicity: boolean
    mode: boolean
    visitType: boolean
    sampling: boolean
    annualControlPlaneId: boolean
}

export interface PACDetailDTO {
    id: string
    periodicity: number[]
    mode: PACVisitingModeEnum
    visitType: PACVisitingTypeEnum
    sampling: boolean
    specifications: string
    note: string
    annualControlPlaneDTO: PACDTO
    customerDTO: {
        id: string
        companyName: string
        headQuarters: string[]
    }
}

export interface GetAllPACDetailsDTO {
    total: number,
    page: number,
    perPage: number | null,
    prev: string | null,
    next: string | null,
    totalPage: number | null,
    data: PACDetailDTO[]
}

export interface GetAllPACDetailsFiltersDTO {
    page: number
    itemsPerPage: number
    order?: boolean
    sort?: string
    customerId?: string
    country?: string
    head_quarter?: string
    periodicity?: number[]
    norm?: string
    year?: number
    searchForAssignment?: boolean
}


export enum PACVisitingModeEnum {
    CON_PREAVVISO = 'CON_PREAVVISO',
    SENZA_PREAVVISO = 'SENZA_PREAVVISO',
    ANNUNCIATA = 'ANNUNCIATA',
    NON_ANNUNCIATA = 'NON_ANNUNCIATA'
}

export enum PACVisitingTypeEnum {
    CONTROLLO_ORDINARIO = 'CONTROLLO_ORDINARIO',
    CONTROLLO_ANNUALE = 'CONTROLLO_ANNUALE',
    CONTROLLO_AGGIUNTIVO = 'CONTROLLO_AGGIUNTIVO',
    CONTROLLO_STRAORDINARIO = 'CONTROLLO_STRAORDINARIO',
    CONTROLLO_MIRATO = 'CONTROLLO_MIRATO',
    CONTROLLO_FASE_AVVIO = 'CONTROLLO_FASE_AVVIO'
}

